export const REDIRECT_URI = `https://${window.location.host}/settings/calendars/google`;
// Generic callback for the new integrations flow; one redirect for all providers.
export const INTEGRATIONS_REDIRECT_URI = `https://${window.location.host}/access`;
export const CLIENT_ID = process.env.REACT_APP_GOOGLE_CAL_CLIENT_ID!;
